var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/LessSign.tsx";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const LessSign = ({
  color = '#353B60',
  bgColor = 'inherit',
  ...other
}) => /*#__PURE__*/_jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...other,
  children: [/*#__PURE__*/_jsx("rect", {
    width: "24",
    height: "24",
    fill: bgColor
  }), /*#__PURE__*/_jsx("path", {
    d: "M16.9561 14.327C17.0984 13.7958 16.8434 13.2616 16.3892 13.1399L8.13263 10.9275C7.67852 10.8059 7.1905 11.141 7.04815 11.6722C6.9058 12.2035 7.16088 12.7377 7.61499 12.8594L15.8716 15.0717C16.3257 15.1934 16.8137 14.8583 16.9561 14.327Z",
    fill: color
  }), /*#__PURE__*/_jsx("path", {
    d: "M7.04196 12.1356C6.89961 11.6044 7.15529 11.07 7.61013 10.9481L15.88 8.73221C16.3348 8.61034 16.8235 8.94529 16.9658 9.47655C17.1082 10.0078 16.8525 10.5422 16.3976 10.6641L8.12777 12.88C7.67293 13.0018 7.18431 12.6669 7.04196 12.1356Z",
    fill: color
  })]
});